import { render, staticRenderFns } from "./MaintenanceUrgencyDropdown.vue?vue&type=template&id=5e83009f&scoped=true&"
import script from "./MaintenanceUrgencyDropdown.vue?vue&type=script&lang=js&"
export * from "./MaintenanceUrgencyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceUrgencyDropdown.vue?vue&type=style&index=0&id=5e83009f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83009f",
  null
  
)

export default component.exports